export class User {
  constructor(
    public id: number = 0,
    public externalId: string = '',
    public email: string = '',
    public firstName: string = '',
    public lastName: string = '',
    public title: string = '',
    public userName: string = '',
    public fullName: string = '',
    public isMember: boolean = false,
    public isPcHolder: boolean = false,
    public securityGroups: string = '',
    public roles: Role[] = [],
  ) { }
}

export type Role = RoleType.TrustAdmin | RoleType.TrustInvestigator |
RoleType.TrustManager | RoleType.TrustSectionLeader | RoleType.TrustSuperAdmin;

export enum RoleType {
  TrustAdmin = 'TrustAdmin',
  TrustInvestigator = 'TrustInvestigator',
  TrustManager = 'Manager',
  TrustSectionLeader = 'SectionLeader',
  TrustSuperAdmin = 'SuperAdmin'
}

